function initCssVariables() {
    function setCssVariables() {
        const vh = window.innerHeight * 0.01;
        const headerHeight = document.querySelector('.header')?.clientHeight || 64;

        document.documentElement.style.setProperty('--vh', `${vh}px`);
        document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
    }

    window.addEventListener('load', setCssVariables);
    window.addEventListener('resize', setCssVariables);
}

// Intersection Observer Utility
export function initScrollAnimations() {
    const targets = document.querySelectorAll('.animated');
    if (!targets.length) return;

    const mobileMql = window.matchMedia('(max-width: 767.98px)');

    const getObserverOptions = () => {
        const isMobile = mobileMql.matches;

        return {
            root: null,
            rootMargin: isMobile ? '0px 0px -5% 0px' : '0px 0px -15% 0px',
            threshold: isMobile ? 0.05 : 0.25,
        };
    };

    let observer = null;

    const onIntersect = (entries, obs) => {
        entries.forEach((entry) => {
            if (!entry.isIntersecting) return;

            entry.target.classList.add('is-animated');
            obs.unobserve(entry.target);
        });
    };

    const createObserver = () => new IntersectionObserver(onIntersect, getObserverOptions());

    const observeAll = () => {
        if (observer) observer.disconnect();
        observer = createObserver();
        targets.forEach((el) => observer.observe(el));
    };

    observeAll();

    if (typeof mobileMql.addEventListener === 'function') {
        mobileMql.addEventListener('change', observeAll);
    } else {
        mobileMql.addListener(observeAll);
    }
}


// Import modules
import './libs/fslightbox.js';
import {initSiteHeader} from './modules/header.js';
import {initContactModal} from './modules/contact-modal.js';
import {initServicesSlider} from './modules/services-slider.js';


// Initialize application
document.addEventListener('DOMContentLoaded', () => {
    initCssVariables();
    initScrollAnimations();
    initSiteHeader();
    initContactModal();
    initServicesSlider();
});



